//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "OCCQuery",
  props: {
    query: String,
    setQuery: Function,
    sort: Object,
    setSort: Function,
    results: Object,
    executeSearch: Function,
    currentResultsStart: Number,
    currentResultsEnd: Number,
  },
  data() {
    return {
      keywords: [],
    };
  },
  watch: {
    query() {
      if (this.query.trim().length > 3) {
        fetch(this.options.keywordsEndpoint, {
          method: 'post',
          body: JSON.stringify(this.query.trim())
        })
          .then(response => response.json())
          .then(data => {
            this.keywords = data.results;
          })
          .catch((error) => {
            console.error('Error:', error);
          });
      }
    }
  },
  computed: {
    label() {
      return `Results ${this.currentResultsStart} - ${this.currentResultsEnd} of ${this.results.totalResultCount}`;
    },
    queryModel: {
      get() {
        return this.query;
      },
      set(val) {
        this.setQuery(val);
      },
    },
    sortModel: {
      get() {
        return this.sort;
      },
      set(val) {
        this.setSort(val);
      },
    },
  },
  methods: {
    // searchForKeyword(el) {
    //  this.setQuery(el.title);
    //  this.executeSearch();
    //  this.setQuery('');
    //  this.keywords = [];
    // }
  }
};
